var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M20 25.145c.119 0 .22-.04.3-.122a.388.388 0 00.123-.285V6.851l-.033-2.116 1.986 2.002L25.5 9.862c.086.098.19.146.309.146.098 0 .187-.04.268-.122a.387.387 0 00.123-.284c0-.098-.05-.19-.147-.277l-5.762-5.778a.292.292 0 00-.13-.098.446.446 0 00-.163-.032.37.37 0 00-.154.032.453.453 0 00-.139.098l-5.794 5.778a.388.388 0 00-.13.277c0 .108.04.203.122.284.081.082.17.122.269.122a.435.435 0 00.309-.146l3.125-3.125 1.985-2.018-.016 2.132v17.887c0 .109.04.204.122.285a.412.412 0 00.301.122zm8.87 11.442c1.313 0 2.306-.344 2.978-1.033.673-.69 1.01-1.674 1.01-2.954V16.242c0-1.28-.337-2.262-1.01-2.946-.672-.683-1.665-1.025-2.978-1.025h-4.541v.846h4.508c.999 0 1.777.266 2.336.798.559.531.838 1.323.838 2.376v16.26c0 1.052-.28 1.847-.838 2.384-.559.537-1.337.806-2.336.806H11.145c-1.041 0-1.83-.269-2.368-.806-.537-.537-.806-1.332-.806-2.384V16.29c0-1.053.269-1.845.806-2.376.537-.532 1.327-.798 2.368-.798h4.557v-.846h-4.59c-1.301 0-2.292.336-2.97 1.009-.678.673-1.017 1.66-1.017 2.962V32.6c0 1.302.34 2.292 1.017 2.97.678.678 1.669 1.017 2.97 1.017H28.87z"
  }))));
}

export default SvgFileUpload;